import { ICatalogItem } from '../../shared/types/card';
import { favoriteActions } from '../../store/favorite/favorite.slice';
import { AppDispatch } from '../../store/store';

export class Favorite {
  //Есть ли товар такой в избранном
  public static isItemExistFavorite(
    basket_catalog_items: ICatalogItem[],
    id: number
  ): boolean {
    if (!basket_catalog_items) return false;
    let ind = basket_catalog_items.findIndex((it) => id == it.id);
    if (ind != -1) {
      return true;
    }

    return false;
  }

  public static toggleFavorite(
    favorites: ICatalogItem[],
    card: ICatalogItem,
    dispatch: AppDispatch
  ) {
    const { setFavoriteItems, setFavoriteQuantity } = favoriteActions;
    if (!favorites) return;
    const isHasItem = Favorite.isItemExistFavorite(favorites, card.id);
    if (!isHasItem) {
      const items = [...favorites, card];
      dispatch(setFavoriteItems(items));
      dispatch(setFavoriteQuantity(items.length));
    } else {
      const items = favorites.filter((f) => f.id !== card.id);
      dispatch(setFavoriteItems(items));
      dispatch(setFavoriteQuantity(items.length));
    }

    return isHasItem;
  }
}
